import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import type { App } from "vue";
import type { Store } from "vuex";

let insightStore: Store<unknown> | null = null;
let appInsightsClient: ApplicationInsights | null = null;

/** Call from bootstrap so `appInsightTrackEvent` can read getters without `Vue.prototype`. */
export function setAppInsightsStore(store: Store<unknown>): void {
  insightStore = store;
}

export function installAppInsightsForVue3(
  app: App,
  options: { instrumentationKey: string },
): void {
  const appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: options.instrumentationKey,
      autoExceptionInstrumented: false,
      enableDebugExceptions: false,
      disableExceptionTracking: true,
      disableAjaxTracking: true,
    },
  });
  appInsights.loadAppInsights();

  const originalTrackEvent = appInsights.trackEvent.bind(appInsights);
  appInsights.trackEvent = function (event: any, customProperties?: any) {
    const properties = event.properties || {};
    properties.ApplicationName = "Client Portal";
    originalTrackEvent({ ...event, properties }, customProperties);
  };

  const originalTrackException = appInsights.trackException.bind(appInsights);
  appInsights.trackException = function (
    exception: any,
    customProperties?: any,
  ) {
    const properties = exception.properties || {};
    properties.ApplicationName = "Client Portal";
    originalTrackException({ ...exception, properties }, customProperties);
  };

  app.config.globalProperties.appInsights = appInsights;
  appInsightsClient = appInsights;
}

/** @deprecated Vue 2 plugin entry; use `installAppInsightsForVue3`. */
export function AppInsights(): void {
  /* no-op — retained for named export compatibility */
}

export function appInsightTrackEvent(
  customProperties: appInsightObject[],
  eventName: string,
) {
  const properties: Record<string, unknown> = {
    contactId: insightStore?.getters["ContactModule/getContactId"],
    serviceProviderId:
      insightStore?.getters["ContactModule/getServiceProviderId"],
  };

  if (customProperties != null && customProperties.length > 0) {
    for (const property of customProperties) {
      properties[property.name] = property.value;
    }
  }

  try {
    appInsightsClient?.trackEvent({
      name: eventName,
      properties: properties as any,
    });
  } catch (error) {
    console.error("error in sending data to App insights:", error);
  }
}

export function appInsightTrackException(
  customProperties: appInsightObject[],
  exception: string,
) {
  const properties: Record<string, unknown> = {
    technicianId: insightStore?.getters["ContactModule/getContactId"],
    serviceProviderId:
      insightStore?.getters["ContactModule/getServiceProviderId"],
  };

  if (customProperties != null && customProperties.length > 0) {
    for (const property of customProperties) {
      properties[property.name] = property.value;
    }
  }

  try {
    appInsightsClient?.trackException({
      exception: new Error(exception),
      properties: properties as any,
    });
  } catch (error) {
    console.error("error in sending data to App insights:", error);
  }
}

export class appInsightObject {
  public name: string = "";
  public value: unknown;
}
